'use client';

import { c as _c } from "react/compiler-runtime";
import { getVideoUploadState, UploadState, UploadStatusType } from '@/services/cms';
import { useRef, useState } from 'react';
import useSWR from 'swr';
const PROCESSING_POLLING_INTERVAL_MS = 5000;
const TRANSCODING_POLLING_INTERVAL_MS = 10000;
const POLLING_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export function useVideoUploadStatus(hubSid, t0) {
  const $ = _c(7);
  const enabled = t0 === undefined ? true : t0;
  const [mountTime] = useState(_temp);
  const pollingStartTimeRef = useRef(mountTime);
  let t1;
  if ($[0] !== hubSid) {
    t1 = async () => {
      const res = await getVideoUploadState(hubSid);
      if (!res || res.status !== 200) {
        return {
          status: "FAILED" as UploadStatusType
        };
      }
      return res.results;
    };
    $[0] = hubSid;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      refreshInterval: data => {
        const isTimeout = Date.now() - pollingStartTimeRef.current > POLLING_TIMEOUT_MS;
        if (isTimeout) {
          return 0;
        }
        if (data?.status === "PROCESSING") {
          return PROCESSING_POLLING_INTERVAL_MS;
        }
        if (data?.status === "TRANSCODING") {
          return TRANSCODING_POLLING_INTERVAL_MS;
        }
        return 0;
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: videoUploadState
  } = useSWR(hubSid && enabled ? `getVideoUploadStatus-${hubSid}` : null, t1, t2);
  const isProcessing = videoUploadState?.status === "PROCESSING" || videoUploadState?.status === "TRANSCODING";
  const isFailed = videoUploadState?.status === "FAILED" || videoUploadState?.status === "UNKNOWN";
  let t3;
  if ($[3] !== isFailed || $[4] !== isProcessing || $[5] !== videoUploadState) {
    t3 = {
      videoUploadState,
      isProcessing,
      isFailed
    };
    $[3] = isFailed;
    $[4] = isProcessing;
    $[5] = videoUploadState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp() {
  return Date.now();
}